module.exports = __webpack_public_path__ + "img/62.4bb29e4d.jpg";